import { useFlagsmithLoading } from '@flagsmith/flagsmith/react';
import { AcquisitionJourneyEnabledContent } from '@/components/EntryPromotionalContent/AcquisitionJourneyEnabledContent';
import { useGetCashbackPercentageValue } from '@/hooks/useGetCashbackPercentageValue';

export const EntryPromotionalContent = () => {
  const flagsmithLoadingState = useFlagsmithLoading();
  const cashbackPercentageValue = useGetCashbackPercentageValue();

  if (flagsmithLoadingState?.isLoading || !cashbackPercentageValue) {
    return null;
  }

  return <AcquisitionJourneyEnabledContent />;
};
